import React from 'react'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'

export const SupportSection = () => {
  return (
    <SupportSectionStyles id='soporte'>
      <StyledSlatInner className='support__inner'>
        <h2 className='support__title'>Soporte</h2>
        <div className='support__grid'>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--support' />
            <div className='support__grid__item__text'>24x7 ó 8x5</div>
          </div>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--tickets' />
            <div className='support__grid__item__text'>Sistema de tickets</div>
          </div>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--remote-sesion' />
            <div className='support__grid__item__text'>Sesión remota</div>
          </div>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--email' />
            <div className='support__grid__item__text'>Correo electrónico</div>
          </div>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--phone' />
            <div className='support__grid__item__text'>Vía telefónica</div>
          </div>
          <div className='support__grid__item'>
            <div className='support__grid__item__icon support__grid__item__icon--technician' />
            <div className='support__grid__item__text'>Personal calificado</div>
          </div>
        </div>
      </StyledSlatInner>
    </SupportSectionStyles>
  )
}

const SupportSectionStyles = StyledSlatOuter.extend`
  background-color: ${({ theme }) => theme.lightBlue};
  color: ${({ theme }) => theme.white};

  .support {
    &__inner {

    }

    &__title {
      text-align: left;
      font-size: 25px;
      text-transform: uppercase;
      @media (min-width: ${({theme}) => theme.large.start}) {
        font-size: 35px;
      }
    }

    &__grid {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex-flow: row;
      flex-wrap: wrap;

      &__item {
        width: 40%;
        display: flex;
        flex-flow: column;
        align-items: center;
        margin-bottom: 20px;
        @media (min-width: ${({theme}) => theme.medium.start}) {
          width: 26%;
        }
        @media (min-width: ${({theme}) => theme.large.start}) {
          width: 10%;
          margin-bottom: 0px;
        }

        &__icon {
          width: 90px;
          height: 90px;
          background-size: contain;
          background-repeat: no-repeat;

          &--support {
            background-image: url(/svg/icon--technical-support--white.svg);
          }

          &--tickets {
            background-image: url(/svg/icon--tickets--white.svg);
          }

          &--remote-sesion {
            background-image: url(/svg/icon--network--white.svg);
          }

          &--email {
            background-image: url(/svg/icon--email--white.svg);
          }

          &--phone {
            background-image: url(/svg/icon--phone-call--white.svg);
          }

          &--technician {
            background-image: url(/svg/icon--technician--white.svg);
          }

        }

        &__text {

        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/SupportSection.js